var n, q;
function u() {
  if (q) return n;
  q = 1;
  function i(r, e) {
    return r === e || r !== r && e !== e;
  }
  return n = i, n;
}
export {
  u as __require
};
